export default "__VITE_ASSET__sBjtj8ot__"